// extracted by mini-css-extract-plugin
export var chevron = "_bo-2";
export var dropdownItems = "_bo-0";
export var item = "_bo-1";